import { Icono, type NombreIcono } from './Icono';
import { Tarjeta } from './Tarjeta';
import { useValorAnimado } from './animation';

interface PropsKpi {
  etiqueta: string;
  valor: string | number;
  icono?: NombreIcono;
  /** Texto ya formateado, por ejemplo "+12%". */
  variacion?: string;
  tendencia?: 'sube' | 'baja';
  pista?: string;
}

export function Kpi({ etiqueta, valor, icono, variacion, tendencia = 'sube', pista }: PropsKpi) {
  const mostrado = useValorAnimado(valor);
  return (
    <Tarjeta relleno={20}>
      <div className="kpi__cabecera">
        <span className="kpi__etiqueta">{etiqueta}</span>
        {icono && (
          <span className="kpi__icono">
            <Icono nombre={icono} tamano={16} />
          </span>
        )}
      </div>
      <div className="kpi__valor">{mostrado}</div>
      {(variacion || pista) && (
        <div className="kpi__pie">
          {variacion && (
            <span className={`kpi__variacion kpi__variacion--${tendencia}`}>
              <Icono nombre={tendencia === 'sube' ? 'trending-up' : 'trending-down'} tamano={12} />
              {variacion}
            </span>
          )}
          {pista && <span className="kpi__pista">{pista}</span>}
        </div>
      )}
    </Tarjeta>
  );
}
